'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateQuotes = exports.quoted = undefined;
var _format = require('@marmalade/format');
var _format2 = _interopRequireDefault(_format);
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _constants = require('./constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var quoted = exports.quoted = function quoted(data) {
  return data[10000] && data[10000].monthlyPremium;
};
var generateQuotes = exports.generateQuotes = function generateQuotes(data) {
  var premiumsToScores = function premiumsToScores(premiums) {
    var scores = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
      for (var _iterator = Object.keys(premiums)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;
        scores[key] = premiums[key].premiumIncludingIpt;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    return scores;
  };
  return {
    quotes: {
      10000: {
        facilityFee: (0, _format2.default)('currency', data[10000].creditFacilityFee),
        firstInstalment: (0, _format2.default)('currency', data[10000].creditFirstInstalment),
        deposit: (0, _format2.default)('currency', data[10000].creditDepositAmount),
        monthly: (0, _format2.default)('currency', data[10000].monthlyPremium),
        annual: (0, _format2.default)('currency', data[10000].premiumIncludingIpt),
        totalPayable: (0, _format2.default)('currency', data[10000].premiumIncludingIpt),
        totalPayableMonthly: (0, _format2.default)('currency', data[10000].creditTotalPayableWithDeposit),
        apr: data[10000].apr || 0,
        months: data[10000].creditNumMonthlyPayments || 12
      },
      payg: {
        rule: data.ppmPremiums.newBusiness.rule,
        cost: data.ppmPremiums.newBusiness.premiumIncludingIpt,
        topup_options: {
          100: premiumsToScores(data.ppmPremiums[100]),
          200: premiumsToScores(data.ppmPremiums[200]),
          300: premiumsToScores(data.ppmPremiums[300]),
          400: premiumsToScores(data.ppmPremiums[400]),
          500: premiumsToScores(data.ppmPremiums[500])
        }
      }
    },
    quoteRef: data.quoteRef
  };
};
var initialState = {
  fetching: false,
  requestError: false,
  quoteError: false,
  quoted: false,
  quoteRef: '',
  params: {
    age: '',
    postcode: '',
    licenceHeld: '',
    licenceType: '',
    regNo: '',
    abiCode: '',
    value: ''
  },
  quotes: []
};
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          fetching: true,
          requestError: false,
          quoteError: false
        });
      }
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, initialState, {
          fetching: false,
          requestError: true
        });
      }
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        if (action.payload.data.status === 'SUCCESS' && quoted(action.payload.data.data)) {
          var data = action.payload.data.data;
          return Object.assign({
            fetching: false,
            requestError: false,
            quoteError: false,
            quoted: true,
            params: action.meta.params
          }, generateQuotes(data));
        }
        return Object.assign({}, state, {
          fetching: false,
          requestError: false,
          quoteError: true,
          quoted: false
        });
      }
    case _constants.actionTypes.CLEAR_QUOTES:
      {
        return initialState;
      }
    default:
      return state;
  }
};